<template>
    <div class="index">
        <div class="top">
            <div>
                 <!-- v-if="isAdd" -->
                <el-button type="success" icon="el-icon-edit-outline" @click="isQuickEnteringDialog = true">蚂蚁保代平台案件录入</el-button>
                <el-button type="primary" icon="el-icon-edit-outline" @click="isBatchImportDialog = true">批量导入</el-button>
            </div>
            <el-button type="primary" icon="el-icon-circle-plus" @click="addAnXinDcTaskTip">确认新增</el-button>
        </div>
        <el-form :model="caseData" :rules="caseRules" ref="ruleForm" label-width="100px">
            <div class="section">
                <div class="title">
                    基本信息
                </div>
                <el-form-item label="赔案号" prop="cClmNo">
                    <el-input v-model="caseData.cClmNo" placeholder="请输入" size="small" class="citem-input"></el-input>
                </el-form-item>
                
                <!-- <div class="item">
                    <div class="label">
                        <span class="dot">*</span>
                        赔案号
                    </div>
                    <div class="value">
                        <el-input v-model="caseData.cClmNo" placeholder="请输入" size="small" class="citem-input"></el-input>
                    </div>
                </div> 
                <div class="item">
                    <div class="label">
                        调查意见
                    </div>
                    <div class="value" style="width:590px">
                        <el-input v-model="caseData.cDoubtOpin" placeholder="请输入" size="small" type="textarea"></el-input>
                    </div>
                </div> -->
                <el-form-item label="调查意见" prop="cDoubtOpin">
                    <el-input v-model="caseData.cDoubtOpin" placeholder="请输入" size="small" type="textarea" style="width:570px"></el-input>
                </el-form-item>


                <el-form-item label="派工时间" prop="DcTaskPgTime">
                    <el-date-picker
                    v-model="caseData.DcTaskPgTime"
                    type="datetime"
                    size="small"
                    class="citem-input"
                    placeholder="选择日期时间"
                    :picker-options="end_Date"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    >
                    </el-date-picker>
                </el-form-item>
                
                
            </div>
            <div class="section">
                <div class="title">
                    保险信息
                </div>
                <el-form-item label="保险公司" prop="companyId">
                    <el-select v-model="caseData.companyId" size="small" placeholder="请选择"  class="citem-input" @change="changeCompany" filterable>
                        <el-option
                        v-for="item in companyList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="委托人" prop="EntrustName">
                    <el-input v-model="caseData.EntrustName" placeholder="请输入" size="small" class="citem-input" ></el-input>
                </el-form-item>
                <el-form-item label="险种类型" prop="cProdType">
                    <el-select v-model="caseData.cProdType" size="small" placeholder="请选择"  class="citem-input">
                        <el-option
                        v-for="item in insuranceList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                
                
                <el-form-item label="保障产品" prop="cProdName">
                    <el-select v-model="caseData.cProdName" size="small" placeholder="请选择"  class="citem-input">
                        <el-option
                        v-for="item in productList"
                        :key="item.name"
                        :label="item.name"
                        :value="item.name">
                        </el-option>
                    </el-select>
                </el-form-item>

                <!-- <div class="item">
                    <div class="label">
                        <span class="dot">*</span>
                        保障产品
                    </div>
                    <div class="value">
                        <el-select v-model="caseData.cProdName" size="small" placeholder="请选择"  class="citem-input">
                            <el-option
                            v-for="item in productList"
                            :key="item.name"
                            :label="item.name"
                            :value="item.name">
                            </el-option>
                        </el-select>
                    </div>
                </div> -->
                

                <el-form-item label="保单号">
                    <el-input v-model="caseData.cPlyNo" placeholder="请输入" size="small" class="citem-input"></el-input>
                </el-form-item>

                <el-form-item label="投保时间" prop="tInsAddTm">
                    <el-date-picker
                    v-model="caseData.tInsAddTm"
                    type="datetime"
                    size="small"
                    class="citem-input"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    placeholder="选择日期时间">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="被保人" prop="cInsuredNme">
                    <el-input v-model="caseData.cInsuredNme" placeholder="请输入" size="small" class="citem-input" @change="cInsuredNmeChange"></el-input>
                </el-form-item>
                <el-form-item label="被保人证件类型" prop="cCertType">
                    <el-select v-model="caseData.cCertType" size="small" placeholder="请选择"  class="citem-input">
                        <el-option
                        v-for="item in InsuredNoTypeList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>

              
                <el-form-item label="被保人证件号" prop="cCertNo">
                    <el-input v-model="caseData.cCertNo" placeholder="请输入" size="small" class="citem-input"></el-input>
                </el-form-item>

            </div>

            <div class="section">
                <div class="title">
                    出险信息
                </div>
                <el-form-item label="出险人" prop="personDanger">
                    <el-input v-model="caseData.personDanger" placeholder="请输入" size="small" class="citem-input"></el-input>
                </el-form-item>
                <el-form-item label="出险时间" prop="tAccdntTm">
                    <el-date-picker
                    v-model="caseData.tAccdntTm"
                    type="datetime"
                    size="small"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    class="citem-input"
                    placeholder="选择日期时间">
                    </el-date-picker>
                </el-form-item>

                <el-form-item label="出险地点">
                    <el-cascader
                    size="small"
                    :options="regionData"
                    v-model="selectedOptions"
                    @change="handleRegionChange">
                    </el-cascader>
                </el-form-item>
                
                <el-form-item label="出险经过">
                    <el-input v-model="caseData.cAccdntPro" placeholder="请输入" size="small" type="textarea" style="width:570px"></el-input>
                </el-form-item>

            </div>
            <div class="section">
                <div class="title">
                    报案信息
                </div>
                <el-form-item label="报案人">
                    <el-input v-model="caseData.cRptName" placeholder="请输入" size="small" class="citem-input"></el-input>
                </el-form-item>

                <el-form-item label="报案人电话">
                    <el-input v-model="caseData.cRptTell" placeholder="请输入" size="small" class="citem-input"></el-input>
                </el-form-item>
               
                <el-form-item label="报案时间">
                    <el-date-picker
                    v-model="caseData.tRptTm"
                    type="datetime"
                    size="small"
                    class="citem-input"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    placeholder="选择日期时间">
                    </el-date-picker>
                </el-form-item>
                
            </div>

            <div class="section">
                <div class="title">
                    <span class="dot">*</span>
                    派工信息
                </div>
                <div style="margin:0 10px;width:100%">
                    <div class="handle">
                        <div>
                            <el-button type="primary" icon="el-icon-circle-plus" size="small" @click="addSurveyDataDialog=true">添加派工信息</el-button>
                            
                            <el-button size="small">保单OCR识别</el-button>
                            <el-button size="small">身份证OCR识别</el-button>
                            <el-button size="small">银行卡OCR识别</el-button>
                            <el-button size="small">驾驶证OCR识别</el-button>
                            <el-button size="small">行驶证OCR识别</el-button>
                        </div>
                    </div>
                    <el-table
                        :data="surveyData"
                        border
                        :header-cell-style="tableHeaderColor"
                        style="width:100%"
                        >
                        <el-table-column
                        type="index"
                        label="序号"
                        width="60"
                        align="center"
                        >
                        </el-table-column>
                    
                        <el-table-column
                        prop="cSvyNeed"
                        label="调查需求"
                        align="center"
                        >
                        </el-table-column>
                        
                        <el-table-column
                        prop="tHopeEndTm"
                        label="期望完成时间"
                        align="center"
                        width="200">
                        <template slot-scope="scope">
                            <span style="color:red">{{scope.row.tHopeEndTm}}</span>
                        </template>
                        </el-table-column>
                        <el-table-column
                        prop="cSvyType"
                        label="疑似类型"
                        align="center"
                        width="150">
                        </el-table-column>
                        <el-table-column
                        prop="cSvyMode"
                        label="案件类型"
                        align="center"
                        width="120">
                        </el-table-column>
                        <el-table-column
                        prop="cSvyPlace"
                        label="调查地点"
                        align="center"
                        width="180"
                        >
                        </el-table-column>
                        
                        <el-table-column
                        prop="cSvyAddr"
                        label="调查地址"
                        align="center"
                        width="240"
                        >
                        </el-table-column>
                        
                        <el-table-column
                        fixed="right"
                        label="操作"
                        width="180px"
                        align="center"
                        >
                        <template slot-scope="scope">
                            <el-button type="text" icon="el-icon-edit" size="mini" @click="surveyDataItemDialogOpen(scope.row,scope.$index)">编辑</el-button>
                            <el-button type="text" icon="el-icon-delete" size="mini" @click="deleteSurveyDataItem(scope.$index)">删除</el-button>
                        </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>

            <div class="section">
                <div class="title">
                    派工资料
                </div>
                <div style="margin:0 10px;width:100%">
                    <div class="materiallist">
                        <div class="material" v-for="(item,index) in surveyInfo" :key="index">
                            <img src="../../../assets/images/icon11.png" alt="" v-if="item.materialType=='mp3'||item.materialType=='aac'||item.materialType=='wav'||item.materialType=='wma'||item.materialType=='flac'||item.materialType=='ape'" :fit="cover" @click="download(item.path,item.name)">
                            <img src="../../../assets/images/icon12.png" alt="" v-else-if="item.materialType=='rmvb'||item.materialType=='rm'||item.materialType=='ts'||item.materialType=='tp'||item.materialType=='avi'||item.materialType=='3gp'||item.materialType=='mp4'||item.materialType=='mkv'" :fit="cover" @click="download(item.path,item.name)">
                            <img src="../../../assets/images/icon13.png" alt="" v-else-if="item.materialType=='xls'||item.materialType=='xlsx'||item.materialType=='doc'||item.materialType=='docx'||item.materialType=='ppt'||item.materialType=='pptx'||item.materialType=='pdf'||item.materialType=='zip'||item.materialType=='rar'" :fit="cover" @click="download(item.path,item.name)">
                            <el-image
                            style="width: 120px; height: 120px"
                            :src="item.path"
                            v-else
                            @click="showImgM(item.path,surveyInfo)"
                            :fit="cover"></el-image>
                            <img src="../../../assets/images/icon08.png" class="close" @click="clearSurveyInfoMaterial(index)" alt="" >
                            <div class="filename">{{item.name}}</div>
                        </div>

                        <div>
                            <el-upload
                                :action="uploadUrl"
                                multiple
                                :show-file-list="false"
                                :http-request="addSurveyInfo"
                                >
                                <el-button type="primary" icon="el-icon-circle-plus-outline">新增</el-button>
                            </el-upload>
                        </div>
                    </div>
                
                </div>
            </div>
         
            <div class="section">
                <div class="title">
                    <span class="dot">*</span>
                    作业机构
                </div>
                <div style="margin:0 10px;width:100%">
                    <div class="handle">
                        <div>
                            <el-button type="primary" icon="el-icon-circle-plus" size="small" @click="isAssignJobAgencies = true">指派作业机构</el-button>
                        </div>
                    </div>
                    <el-table
                        :data="caseData.dispatchDoubtTasks"
                        border
                        :header-cell-style="tableHeaderColor"
                        style="width: 100%">
                        <el-table-column
                        type="index"
                        width="80"
                        label="序号"
                        align="center"
                        >
                        </el-table-column>
                        <el-table-column
                        prop="operatorMechanism"
                        label="机构名称"
                        align="center"
                        >
                        </el-table-column>
                        <el-table-column
                        prop="dcOperator"
                        label="调查员"
                        align="center"
                        >
                        </el-table-column>
                        

                        <el-table-column
                        prop="executeAction"
                        label="任务状态"
                        align="center"
                        >
                        <template slot-scope="scope">
                            <!-- {{scope.row.executeAction==0?"待接收":""}}
                            {{scope.row.executeAction==10?"待派工":""}}
                            {{scope.row.executeAction==20?"调查中":""}}
                            {{scope.row.executeAction==25?"待审核":""}}
                            {{scope.row.executeAction==30?"已提交":""}}
                            {{scope.row.executeAction==40?"任务退回":""}}
                            {{scope.row.executeAction==50?"完成":""}} -->

                            {{scope.row.executeAction==0?"新任务":""}}
                            {{scope.row.executeAction==10?"任务待派调查员":""}}
                            {{scope.row.executeAction==20?"任务作业中":""}}
                            {{scope.row.executeAction==25?"任务待机构审核":""}}
                            {{scope.row.executeAction==26?"异地作业审核":""}}
                            {{scope.row.executeAction==30?"任务待总部审核":""}}
                            {{scope.row.executeAction==40?"任务退回":""}}
                            {{scope.row.executeAction==50?"任务完成":""}}
                            {{scope.row.executeAction==70?"取消委托":""}}
                            
                        </template>
                        </el-table-column>
                        <el-table-column
                        prop="taskFee"
                        label="公估费用"
                        align="center"
                        >
                        </el-table-column>
                        
                        <el-table-column
                        prop="isZhuPaiJiGou"
                        label="是否主查机构"
                        align="center"
                        >
                        <template slot-scope="scope">
                            {{scope.row.isZhuPaiJiGou?"是":"否"}}
                        </template>
                        </el-table-column>
                        <el-table-column
                        fixed="right"
                        label="操作"
                        width="280px"
                        align="center"
                        >
                        <template slot-scope="scope">
                            <el-button type="text" icon="el-icon-delete" size="mini" @click="cancelAssign(scope.$index)">删除</el-button>
                            <el-button type="text" icon="el-icon-delete" size="mini" @click="editAssignTip(scope.$index)">编辑</el-button>
                        </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
                
            <div class="item" style="width:100%" v-if="isFinalCase">
                <el-checkbox v-model="isFinanceDcTaskAction">案件是否已完成</el-checkbox>
            </div>

            <el-form-item label="调查结论" v-if="isFinanceDcTaskAction&&isFinalCase" prop="cConclusion">
                <el-select v-model="caseData.cConclusion" size="small" placeholder="请选择" @change="isBigCaseChange">
                    <el-option
                    v-for="item in cConclusionList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="调查意见" v-if="isFinanceDcTaskAction&&isFinalCase" prop="cConcRst">
                <el-input v-model="caseData.cConcRst" placeholder="" size="small" type="textarea" :rows="8" style="width:570px"></el-input>
            </el-form-item>

            <el-form-item label="拒赔原因"  v-if="researchConclusions.cConclusion=='3'&&isFinanceDcTaskAction&&isFinalCase">
                <el-input v-model="researchConclusions.cRefuseRsn" placeholder="" size="small" type="textarea" style="width:570px"></el-input>
            </el-form-item>

            <el-form-item label="拒赔金额"  v-if="researchConclusions.cConclusion=='3'&&isFinanceDcTaskAction&&isFinalCase">
                <el-input v-model="researchConclusions.nRefusePayAmt" placeholder="请输入" size="small" type="number"></el-input>
            </el-form-item>

            <el-form-item label="减损金额"  v-if="researchConclusions.cConclusion=='2'&&isFinanceDcTaskAction&&isFinalCase">
                <el-input v-model="researchConclusions.nRefusePayAmt" placeholder="请输入" size="small" type="number"></el-input>
            </el-form-item>

            <!-- <div class="item" v-if="isFinanceDcTaskAction&&isFinalCase">
                <div class="label">
                    <span class="dot">*</span>
                    调查结论
                </div>
                <div class="value">
                    <el-select v-model="researchConclusions.cConclusion" size="small" placeholder="请选择" @change="isBigCaseChange">
                        <el-option
                        v-for="item in cConclusionList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                </div>
            </div>
            
            <div class="item" v-if="isFinanceDcTaskAction&&isFinalCase">
                <div class="label">
                    <span class="dot">*</span>
                    调查意见
                </div>
                <div class="value" style="width:588px">
                    <el-input v-model="researchConclusions.cConcRst" placeholder="" size="small" type="textarea" :rows="8"></el-input>
                    
                </div>
            </div>
            <div class="item" v-if="researchConclusions.cConclusion=='3'&&isFinanceDcTaskAction&&isFinalCase">
                <div class="label">
                    拒赔原因
                </div>
                <div class="value" style="width:890px">
                    <el-input v-model="researchConclusions.cRefuseRsn" placeholder="" size="small" type="textarea" ></el-input>
                </div>
            </div>
            <div class="item" v-if="researchConclusions.cConclusion=='3'&&isFinanceDcTaskAction&&isFinalCase">
                <div class="label">
                    拒赔金额
                </div>
                <div class="value">
                    <el-input v-model="researchConclusions.nRefusePayAmt" placeholder="请输入" size="small" type="number"></el-input>
                </div>
            </div>
            <div class="item" v-if="researchConclusions.cConclusion=='2'&&isFinanceDcTaskAction&&isFinalCase">
                <div class="label">
                    减损金额
                </div>
                <div class="value">
                    <el-input v-model="researchConclusions.nDeroAmt" placeholder="请输入" size="small" type="number"></el-input>
                </div>
            </div> -->



            <!-- <div class="btns">
                <el-button type="primary" icon="el-icon-circle-plus" @click="addAnXinDcTaskTip">确认新增</el-button>
            </div> -->

          
            <div class="btns">
                <el-form-item>
                    <el-button type="primary" icon="el-icon-circle-plus" @click="submitForm('ruleForm')">确认新增</el-button>
                </el-form-item>
            </div> 
        </el-form>

       
       <el-dialog :close-on-click-modal="true" :visible.sync="surveyDataItemDialog" title="调查信息详情" width="800px">
            <div class="section">
                <div class="title">
                    调查信息
                </div>
                <div class="item">
                    <div class="label">
                        调查需求
                    </div>
                    <div class="value" style="width:590px">
                        <el-autocomplete
                            class="inline-input"
                            v-model="surveyDataItem.cSvyNeed"
                            :fetch-suggestions="querySearch"
                            placeholder=""
                            @select="handleSelect"
                            @keyup.enter.native="search"
                            size="small"
                        >
                            <template slot-scope="{ item }">
                                <div class="name">{{ item.label }}</div>
                            </template>
                        </el-autocomplete>
                        <!-- <el-select v-model="surveyDataItem.cSvyNeedCode" size="small" placeholder="请选择"  class="citem-input" @change="changeCSvyNeed">
                            <el-option
                            v-for="item in cSvyNeedList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select> -->
                    </div>
                </div>
                
                <div class="item">
                    <div class="label">
                        期望完成时间
                    </div>
                    <div class="value">
                        <el-date-picker
                        v-model="surveyDataItem.tHopeEndTm"
                        type="date"
                        size="small"
                        class="citem-input"
                        format="yyyy-MM-dd"
                        placeholder="选择日期时间">
                        </el-date-picker>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        <div class="dot">*</div>
                        疑案类型
                    </div>
                    <div class="value">
                        <el-select v-model="surveyDataItem.cSvyTypeCode" size="small" placeholder="请选择"  class="citem-input" @change="changeCSvyType">
                            <el-option
                            v-for="item in cSvyTypeList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        <div class="dot">*</div>
                        案件类型
                    </div>
                    <div class="value">
                        <el-select v-model="surveyDataItem.cSvyModeCode" size="small" placeholder="请选择"  class="citem-input" @change="changeCSvyMode">
                            <el-option
                            v-for="item in cSvyModeList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        调查地点
                    </div>
                    <div class="value">
                        <el-select v-model="surveyDataItem.cSvyPlaceCode" size="small" placeholder="请选择"  class="citem-input" @change="changeCSvyPlace">
                            <el-option
                            v-for="item in cSvyPlaceList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        调查地址
                    </div>
                    <div class="value">
                        <el-input v-model="surveyDataItem.cSvyAddr" placeholder="请输入" size="small"></el-input>
                    </div>
                </div>
                
                <!-- <div class="item">
                    <div class="label">
                        调查内容
                    </div>
                    <div class="value" style="width:590px">
                        <el-input v-model="assignData.cDoubtOpin" placeholder="请输入" size="small" type="textarea"></el-input>
                    </div>
                </div> -->
                <div class="btns">
                    <el-button type="primary" icon="el-icon-edit" @click="surveyDataItemDialog=false">关闭</el-button>
                </div>
            </div>
        </el-dialog>

        <el-dialog :close-on-click-modal="false" :visible.sync="addSurveyDataDialog" title="新增调查信息详情" width="800px">
            <div class="section">
                <div class="title">
                    调查信息
                </div>
                <div class="item">
                    <div class="label">
                        <div class="dot">*</div>
                        调查需求
                    </div>
                    <div class="value" style="width:590px">
                        <el-autocomplete
                            class="inline-input"
                            v-model="addSurveyData.cSvyNeed"
                            :fetch-suggestions="querySearch"
                            placeholder=""
                            @select="handleSelect"
                            @keyup.enter.native="search"
                            size="small"
                        >
                            <template slot-scope="{ item }">
                                <div class="name">{{ item.label }}</div>
                            </template>
                        </el-autocomplete>
                        <!-- <el-select v-model="addSurveyData.cSvyNeedCode" size="small" placeholder="请选择"  class="citem-input" @change="changeCSvyNeed">
                            <el-option
                            v-for="item in cSvyNeedList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select> -->
                    </div>
                </div>
                
                <div class="item">
                    <div class="label">
                        期望完成时间
                    </div>
                    <div class="value">
                        <el-date-picker
                        v-model="addSurveyData.tHopeEndTm"
                        type="date"
                        size="small"
                        class="citem-input"
                        value-format="yyyy-MM-dd"
                        placeholder="选择日期时间">
                        </el-date-picker>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        <div class="dot">*</div>
                        疑案类型
                    </div>
                    <div class="value">
                        <el-select v-model="addSurveyData.cSvyTypeCode" size="small" placeholder="请选择"  class="citem-input" @change="changeCSvyType">
                            <el-option
                            v-for="item in cSvyTypeList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        <div class="dot">*</div>
                        案件类型
                    </div>
                    <div class="value">
                        <el-select v-model="addSurveyData.cSvyModeCode" size="small" placeholder="请选择"  class="citem-input" @change="changeCSvyMode">
                            <el-option
                            v-for="item in cSvyModeList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        调查地点
                    </div>
                    <div class="value">
                        
                        <el-select v-model="addSurveyData.cSvyPlaceCode" size="small" placeholder="请选择"  class="citem-input" @change="changeCSvyPlace">
                            <el-option
                            v-for="item in cSvyPlaceList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        调查地址
                    </div>
                    <div class="value">
                        <el-input v-model="addSurveyData.cSvyAddr" placeholder="请输入" size="small"></el-input>
                    </div>
                </div>
                
               <div class="btns">
                    <el-button type="primary" icon="el-icon-edit" @click="addSurveyDataFun">确认新增</el-button>
                </div>
            </div>
        </el-dialog>
        
        <!-- 大图预览 -->
        <el-image-viewer
            v-if="showBigImg"
            :on-close="closeViewer"
            :url-list="showBigImgList"
            :initial-index="imgIndex"
        />
        <el-dialog :close-on-click-modal="false" :visible.sync="isQuickEnteringDialog" title="蚂蚁保代平台案件录入" width="1000px">
            <div class="content">
                <el-input v-model="dataStr" placeholder="请输入" type="textarea" :rows="14"></el-input>
            </div>
            <el-form :model="dispatchDoubtTasks" :rules="dispatchDoubtTasksRules" ref="dispatchDoubtTasksRules" label-width="120px">
                <div class="inputs">
                    <el-form-item label="机构" prop="operatorMechanism">
                        <div class="value" style="width:270px">
                            <el-input v-model="dispatchDoubtTasks.operatorMechanism" placeholder="请输入" size="small" disabled></el-input>
                            <div>
                                <el-button type="primary" size="small" icon="el-icon-edit-outline" @click="isMechanismDialog = true">选择</el-button>
                            </div>
                        </div>
                    </el-form-item>
                    <el-form-item label="调查人员" prop="dcOperator">
                        <div class="value" style="width:270px">
                            <el-input v-model="dispatchDoubtTasks.dcOperator" placeholder="请输入" size="small" disabled></el-input>
                            <div>
                                <el-button type="primary" size="small" icon="el-icon-edit-outline" @click="queryUserByMechanismId">选择</el-button>
                            </div>
                        </div>
                    </el-form-item>
                    <el-form-item label="调查要求" prop="dcyq">
                        <el-input v-model="dispatchDoubtTasks.dcyq" placeholder="请输入" size="small" type="textarea" style="width:570px"></el-input>
                    </el-form-item>
                    <el-form-item label="公估费用" prop="taskFee">
                        <div class="value" style="width:270px">
                            <el-input v-model="dispatchDoubtTasks.taskFee" placeholder="请输入" size="small" type="number"></el-input>
                        </div>
                            
                    </el-form-item>
                    <el-form-item label="公估费为0原因" v-if="dispatchDoubtTasks.taskFee=='0'" prop="taskFeeReason" >
                        <!-- <el-input v-model="dispatchDoubtTasks.taskFee" placeholder="请输入" size="small" type="number"></el-input> -->
                        <div class="value" style="width:270px">
                            <el-select v-model="dispatchDoubtTasks.taskFeeReason" size="small" placeholder="请选择" class="citem-input">
                                <el-option
                                v-for="item in taskFeeReasonList"
                                :key="item"
                                :label="item"
                                :value="item">
                                </el-option>
                            </el-select>
                        </div>
                    </el-form-item>
                    <el-form-item label="奖励费用" prop="rewardFee" >
                        <div class="value" style="width:270px">
                            <el-input v-model="dispatchDoubtTasks.rewardFee" placeholder="请输入" size="small" type="number"></el-input>
                        </div>
                    </el-form-item>
                    <el-form-item label="派工时间" prop="DcTaskPgTime" >
                        <div class="value" style="width:270px">
                            <el-date-picker
                            v-model="dispatchDoubtTasks.DcTaskPgTime"
                            type="datetime"
                            size="small"
                            class="citem-input"
                            :picker-options="end_Date"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            placeholder="选择日期时间">
                            </el-date-picker>
                        </div>
                        
                    </el-form-item>
                    <el-form-item label="案件类型" prop="cSvyModeCode" >
                        <div class="value" style="width:215px">
                            <el-select v-model="dispatchDoubtTasks.cSvyModeCode" size="small" placeholder="请选择"  class="citem-input" @change="changeCSvyMode">
                                <el-option
                                v-for="item in cSvyModeList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                            </el-select>
                            
                        </div>
                    </el-form-item>
                    <div class="item" style="width:100%;margin-left:48px">
                        <el-checkbox v-model="isFinanceDcTaskAction">案件是否已完成</el-checkbox>
                    </div>


                    <el-form-item label="调查结论" v-if="isFinanceDcTaskAction" prop="cConclusion">
                        <el-select v-model="dispatchDoubtTasks.cConclusion" size="small" placeholder="请选择" @change="isBigCaseChange">
                            <el-option
                            v-for="item in cConclusionList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item label="调查意见" v-if="isFinanceDcTaskAction" prop="cConcRst">
                        <el-input v-model="dispatchDoubtTasks.cConcRst" placeholder="" size="small" type="textarea" :rows="8" style="width:570px"></el-input>
                    </el-form-item>

                    <el-form-item label="拒赔原因"  v-if="dispatchDoubtTasks.cConclusion=='3'&&isFinanceDcTaskAction">
                        <el-input v-model="researchConclusions.cRefuseRsn" placeholder="" size="small" type="textarea" style="width:570px"></el-input>
                    </el-form-item>

                    <el-form-item label="拒赔金额"  v-if="dispatchDoubtTasks.cConclusion=='3'&&isFinanceDcTaskAction">
                        <div class="value" style="width:270px">
                            <el-input v-model="researchConclusions.nRefusePayAmt" placeholder="请输入" size="small" type="number"></el-input>
                        </div>
                    </el-form-item>

                    <el-form-item label="减损金额"  v-if="dispatchDoubtTasks.cConclusion=='2'&&isFinanceDcTaskAction">
                        <div class="value" style="width:270px">
                            <el-input v-model="researchConclusions.nRefusePayAmt" placeholder="请输入" size="small" type="number"></el-input>
                        </div>
                    </el-form-item>
                    
                    <div class="btns" style="margin-top:20px">
                        <el-form-item>

                            <el-button type="primary" @click="dataSubmit('dispatchDoubtTasksRules')">确认提交</el-button>
                        </el-form-item>
                    </div>
                </div>
            </el-form>
        </el-dialog>


        <el-dialog :close-on-click-modal="false" :visible.sync="isAssignJobAgencies" title="指派机构" width="800px">
            <div class="dialog">
                <div class="item">
                    <div class="label">
                        <span class="dot">*</span>
                        机构：
                    </div>
                    <div class="value" style="width:300px">
                        <el-input v-model="assignJobAgenciesData.operatorMechanism" placeholder="请输入" size="small" disabled></el-input>
                        <el-button type="primary" size="small" icon="el-icon-edit-outline" @click="isMechanismDialog = true">选择</el-button>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        调查人员：
                    </div>
                    <div class="value" style="width:300px">
                        <el-input v-model="assignJobAgenciesData.dcOperator" placeholder="请输入" size="small" disabled></el-input>
                        <el-button type="primary" size="small" icon="el-icon-edit-outline" @click="queryUserByMechanismId">选择</el-button>
                    </div>
                </div>
                <div class="item" style="color: #ff0000; font-size: 16px;">
                <div class="label">
                    <!-- <span>*</span> -->
                    是否推送:
                </div>
                
                <div class="input" >
                    <!-- <el-input v-model="assets.yuGuFee" type="number" size="small" placeholder=""></el-input> -->
                    <el-checkbox  v-model="assignJobAgenciesData.isPush" style="color: #ff0000;font-size: 16px;">是否推送宝莲灯协同网</el-checkbox>
                </div>
            </div>
            <div class="item">
                    <div class="label">
                        <span class="dot">*</span>
                        异地作业费
                    </div>
                    <div class="value" style="width:300px">
                        <el-input v-model="assignJobAgenciesData.ydPrice" placeholder="请输入" size="small" type="number"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        调查要求：
                    </div>
                    <div class="value" style="width:500px">
                        <el-input v-model="assignJobAgenciesData.dcyq" placeholder="请输入" size="small" type="textarea"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        <span class="dot">*</span>
                        公估费用
                    </div>
                    <div class="value" style="width:300px">
                        <el-input v-model="assignJobAgenciesData.taskFee" placeholder="请输入" size="small" type="number"></el-input>
                    </div>
                </div>
               
                <div class="item" v-if="assignJobAgenciesData.taskFee=='0'">
                    <div class="label">
                        <span class="dot">*</span>
                        公估费为0原因
                    </div>
                    <div class="value" style="width:300px">
                        <el-select v-model="assignJobAgenciesData.taskFeeReason" size="small" placeholder="请选择" class="citem-input">
                            <el-option
                            v-for="item in taskFeeReasonList"
                            :key="item"
                            :label="item"
                            :value="item">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        奖励费用
                    </div>
                    <div class="value" style="width:300px">
                        <el-input v-model="assignJobAgenciesData.rewardFee" placeholder="请输入" size="small" type="number"></el-input>
                    </div>
                </div>
                <div class="item">
                    <el-checkbox v-model="assignJobAgenciesData.isZhuPaiJiGou">主案机构</el-checkbox>
                </div>

                <div class="dialog-btn">
                    <el-button type="primary" icon="el-icon-circle-plus-outline" @click="affirmMechanism">确定</el-button>
                </div>
            </div>
        </el-dialog>

        <el-dialog :close-on-click-modal="false" :visible.sync="isEditAssignJobAgencies" title="修改指派机构" width="800px">
            <div class="dialog">
                <div class="item">
                    <div class="label">
                        <span class="dot">*</span>
                        机构：
                    </div>
                    <div class="value" style="width:300px">
                        <el-input v-model="editAssignJobAgenciesData.operatorMechanism" placeholder="请输入" size="small" disabled></el-input>
                        <el-button type="primary" size="small" icon="el-icon-edit-outline" @click="isMechanismDialog = true">选择</el-button>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        调查人员：
                    </div>
                    <div class="value" style="width:300px">
                        <el-input v-model="editAssignJobAgenciesData.dcOperator" placeholder="请输入" size="small" disabled></el-input>
                        <el-button type="primary" size="small" icon="el-icon-edit-outline" @click="queryUserByMechanismId">选择</el-button>
                    </div>
                </div>
                <div class="item" style="color: #ff0000; font-size: 16px;">
                <div class="label">
                    <!-- <span>*</span> -->
                    是否推送:
                </div>
                <div class="input" >
                    <!-- <el-input v-model="assets.yuGuFee" type="number" size="small" placeholder=""></el-input> -->
                    <el-checkbox  v-model="editAssignJobAgenciesData.isPush" style="color: #ff0000;font-size: 16px;">是否推送宝莲灯协同网</el-checkbox>
                </div>
            </div>
            <div class="item">
                    <div class="label">
                        <span class="dot">*</span>
                        异地作业费
                    </div>
                    <div class="value" style="width:300px">
                        <el-input v-model="editAssignJobAgenciesData.ydPrice" placeholder="请输入" size="small" type="number"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        调查要求：
                    </div>
                    <div class="value" style="width:500px">
                        <el-input v-model="editAssignJobAgenciesData.dcyq" placeholder="请输入" size="small" type="textarea"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        <span class="dot">*</span>
                        公估费用
                    </div>
                    <div class="value" style="width:300px">
                        <el-input v-model="editAssignJobAgenciesData.taskFee" placeholder="请输入" size="small" type="number"></el-input>
                    </div>
                </div>
                <div class="item" v-if="editAssignJobAgenciesData.taskFee=='0'">
                    <div class="label">
                        <span class="dot">*</span>
                        公估费为0原因
                    </div>
                    <div class="value" style="width:300px">
                        <el-select v-model="editAssignJobAgenciesData.taskFeeReason" size="small" placeholder="请选择" class="citem-input">
                            <el-option
                            v-for="item in taskFeeReasonList"
                            :key="item"
                            :label="item"
                            :value="item">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        奖励费用
                    </div>
                    <div class="value" style="width:300px">
                        <el-input v-model="editAssignJobAgenciesData.rewardFee" placeholder="请输入" size="small" type="number"></el-input>
                    </div>
                </div>
                <div class="item">
                    <el-checkbox v-model="editAssignJobAgenciesData.isZhuPaiJiGou">主案机构</el-checkbox>
                </div>

                <div class="dialog-btn">
                    <el-button type="primary" icon="el-icon-circle-plus-outline" @click="editAffirmMechanism">确定</el-button>
                </div>
            </div>
        </el-dialog>

        <el-dialog :close-on-click-modal="false" :visible.sync="isMechanismDialog" title="选择机构" width="800px">
            <div class="condition">
                <div class="item">
                    <div class="label">机构名称:</div>
                    <el-input v-model="conditionDataMechanism.Name" size="small" placeholder="请输入机构名称"></el-input>
                </div>
                <el-button type="primary" size="small" @click="selectDataMechanism()">查询</el-button>
                <el-button type="" size="small" @click="resetMechanism()">重置</el-button>
            </div>
            <el-table
            ref="multipleTable"
            :data="mechanismList"
            border
            :header-cell-style="tableHeaderColor"
            style="width:100%"
            height="400px"
            >
           
            <el-table-column
            type="index"
            label="序号"
            width="60"
            align="center"
            >
            </el-table-column>
            <el-table-column
            prop="name"
            label="机构名称"
            align="center"
            >
            </el-table-column>
            <el-table-column
            prop="code"
            label="所在地区"
            align="center"
            >
            <template slot-scope="scope">
                {{scope.row.province}}
                {{scope.row.city}}
                {{scope.row.district}}
            </template>

            </el-table-column>
            <el-table-column
                fixed="right"
                label="操作"
                width="180px"
                align="center"
                >
                <template slot-scope="scope">
                    <el-button type="primary" @click="selectMechanism(scope.row)" icon="el-icon-edit-outline">确 定</el-button>
                </template>
                </el-table-column>
            </el-table>
            <div class="page">
                <el-pagination
                @current-change="handleCurrentChangeMechanism"
                    background
                    layout="prev, pager, next, total"
                    :total="totalCountMechanism"
                    :current-page="conditionDataMechanism.page"
                    :page-size="conditionDataMechanism.pageSize">
                </el-pagination>
            </div>
            <div class="footer" style="margin-top:20px">
                <el-button icon="el-icon-circle-close" @click="isMechanismDialog=false">关 闭</el-button>
            </div>
        </el-dialog>


        <el-dialog :close-on-click-modal="false" :visible.sync="userDialog" title="选择人员" width="600px">
            <div class="condition">
                <div class="item">
                    <div class="label">人员名称:</div>
                    <el-input v-model="userConditionData.name" size="small" placeholder="请输入"></el-input>
                </div>
                <el-button type="primary" size="small" @click="selectUserData()">查询</el-button>
                <el-button type="warning" size="small" @click="resetUser()">重置</el-button>
            </div>
            <div class="table">
                <el-table
                    :data="userList"
                    border
                    :header-cell-style="tableHeaderColor"
                    style="width: 100%">
                    
                    <el-table-column
                    prop="name"
                    label="用户名称"
                    align="center"
                    >
                    </el-table-column>
                    
                    <el-table-column
                    prop="roleNames"
                    label="关联角色"
                    align="center"
                    >
                    </el-table-column>
                    <el-table-column
                    fixed="right"
                    label="操作"
                    align="center"
                    >
                    <template slot-scope="scope">
                        <el-button type="text" size="mini" icon="el-icon-circle-check" @click="selectPerson(scope.row)">确认指派</el-button>
                    </template>
                    </el-table-column>
                </el-table>
                <div class="page">
                    <el-pagination
                    @current-change="handleCurrentChangeUser"
                        background
                        layout="prev, pager, next, total"
                        :total="userTotalCount"
                        :current-page="userConditionData.page"
                        :page-size="userConditionData.pageSize">
                    </el-pagination>
                </div>
            </div>
        </el-dialog>


        

        <el-dialog :close-on-click-modal="false" :visible.sync="isBatchImportDialog" title="批量导入" width="600px">
            <div class="product-report-radio">
                <el-radio v-model="batchImportType" label="1">中国人民健康保险股份有限公司</el-radio>
            </div>
            <div class="product-report-radio">
                <el-radio v-model="batchImportType" label="22">标准案件导入</el-radio>

                <el-button type="text" icon="el-icon-download" @click="downloadExcel">下载导入模板</el-button>

            </div>

            <div class="product-report-btn">
                <el-upload
                    :action="uploadUrl"
                    Multiple
                    :show-file-list="false"
                    :http-request="batchImport"
                    >
                    <el-button type="success" icon="el-icon-upload">导入excel</el-button>
                    
                    <!-- <el-button type="primary" icon="el-icon-download" @click="batchImport">确认生成</el-button> -->
                </el-upload>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import api from '../../../api/main'
import { regionData , CodeToText } from "element-china-area-data";
import { cCourPlaceList , cCourProList , cCourRelaList,InsuredNoTypeList,CCourModeList ,RefuseRsnList  ,cSvyNeedList,cSvyModeList,cSvyPlaceList,cSvyTypeList,insuranceList,taskFeeReasonList} from "../../../assets/selectList/anxin";
import { parseTimeS,isPhoneNumber } from "../../../utils/index";
 import "../../../utils/dialog"
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
export default {
    name: 'index',
    components:{
        ElImageViewer
    },
    watch: {
    },
    data () {
        return {
            insuranceList:insuranceList,
            cSvyNeedList:cSvyNeedList,
            cSvyModeList:cSvyModeList,
            cSvyPlaceList:cSvyPlaceList,
            cSvyTypeList:cSvyTypeList,
            taskFeeReasonList:taskFeeReasonList,
            uploadUrl:'',
            regionData:regionData,
            InsuredNoTypeList:InsuredNoTypeList,
            caseData:{
                cClmNo:'',
                cProdName:'',
                personDanger:'',
                EntrustName:'',
                dispatchDoubtTasks:[
                    {
                        operatorMechanism:localStorage.getItem('mechanism'),
                        operatorMechanismId:localStorage.getItem('mechanismid'),
                        dcOperator:'',
                        dcOperatorId:null,
                        dcyq:'',
                        isZhuPaiJiGou:true,
                        taskFee:null,
                        taskFeeReason:null,
                        rewardFee:null,
                        isPush: false,
                        ydPrice: null
                    }
                ],
                materialItems:[],
                isTranstion:false,
            },
            dispatchDoubtTasks:{
                operatorMechanism:localStorage.getItem('mechanism'),
                operatorMechanismId:localStorage.getItem('mechanismid'),
                dcOperator:'',
                dcOperatorId:null,
                dcyq:'',
                isZhuPaiJiGou:true,
                taskFee:null,
                taskFeeReason:null,
                rewardFee:null,
                isPush: false,
                ydPrice: null
            },
            selectedOptions:[],
            isAddDoubtCourse:false,

            surveyInfo:[],
           
           
            isEditDoubtCourse:false,
            isAddDoubtCourse:false,
            surveyDataItemDialog:false,
            surveyDataItem:{},
            
            surveyData:[],

            addSurveyData:{},
            addSurveyDataDialog:false,

            companyList:[],
            productList:[],
            appraisalFee:null,
            isQuickEnteringDialog:false,
            dataStr:'',

            isAssignJobAgencies:false,

            assignJobAgenciesData:{},
            mechanismList:[],
            conditionDataMechanism:{
                Name:'',
                page:1,
                pageSize:10
            },
            isMechanismDialog:false,
            btnsList:[],
            isAdd:false,

            showBigImg:false,

            addData:{
                DcTaskPgTime:'',
                operatorMechanism:'',
                operatorMechanismId:'',
                taskFee:0,
                cSvyModeCode:'',
                cSvyTypeCode:'7',
            },


            userConditionData:{
                name:'',
                page:1,
                pageSize:10,
            },
            userList:[],
            userDialog:false,
            userTotalCount:0,

            quickEnteringMechanism:[],

            editAssignJobAgenciesData:{},
            isEditAssignJobAgencies:false,
            assignJobAgenciesDataIndex:0,

            isFinanceDcTaskAction:false,
            isFinalCase:false,
            researchConclusions:{
                cConclusion:'',
                cConcRst:'',
                cRefuseRsn:'',
                nRefusePayAmt:'',
                nDeroAmt:'',
            },
            cConclusionList:[{
                label:'正常赔付',
                value:'1',
            },{
                label:'减损',
                value:'2',
            },{
                label:'拒赔',
                value:'3',
            }],


            caseRules: {
                cClmNo: [
                    { required: true, message: '请输入赔案号', trigger: 'blur' },
                ],
                DcTaskPgTime: [
                    { required: true, message: '请输入派工时间', trigger: 'blur' },
                ],
                companyId: [
                    { required: true, message: '请输入保险信息', trigger: 'blur' },
                ],
                cProdType: [
                    { required: true, message: '请输入险种类型', trigger: 'blur' },
                ],
                cProdName: [
                    { required: true, message: '请输入保障产品', trigger: 'blur' },
                ],
                cInsuredNme: [
                    { required: true, message: '请输入被保人', trigger: 'blur' },
                ],
                cCertType: [
                    { required: true, message: '请输入被保人证件类型', trigger: 'blur' },
                ],
                cCertNo: [
                    { required: true, message: '请输入被保人证件号', trigger: 'blur' },
                ],
                personDanger: [
                    { required: true, message: '请输入出险人', trigger: 'blur' },
                ],



                cConclusion: [
                    { required: true, message: '请输入调查结论', trigger: 'blur' },
                ],
                cConcRst: [
                    { required: true, message: '请输入调查意见', trigger: 'blur' },
                ],
            },

            dispatchDoubtTasksRules: {
                
                operatorMechanism: [
                    { required: true, message: '请输入机构', trigger: 'blur' },
                ],
                dcOperator: [
                    { required: true, message: '请输入调查人员', trigger: 'blur' },
                ],
                taskFee: [
                    { required: true, message: '请输入公估费用', trigger: 'blur' },
                ],
                DcTaskPgTime: [
                    { required: true, message: '请输入派工时间', trigger: 'blur' },
                ],
                cSvyModeCode: [
                    { required: true, message: '请输入案件类型', trigger: 'blur' },
                ],
                



                cConclusion: [
                    { required: true, message: '请输入调查结论', trigger: 'blur' },
                ],
                cConcRst: [
                    { required: true, message: '请输入调查意见', trigger: 'blur' },
                ],
            },
            isBatchImportDialog:false,
            batchImportType:'1',
            end_Date:{
                disabledDate:time => {
                    return time.getTime() >= Date.now()+10
                }
            }
        }
    },
    created(){
        

    },
    mounted(){
        
        this.btnsList = JSON.parse(localStorage.getItem('btns'));
        for(let index in this.btnsList){
            if(this.btnsList[index].name == '蚂蚁保代平台案件录入'&&this.btnsList[index].isCheck){
                this.isAdd = true;
            }
        }
        this.getCompanyList();
        this.queryMechanism();

    },
    methods:{
        cInsuredNmeChange(val){
            console.log(val);
            this.caseData.personDanger = val;
            this.$forceUpdate();
        },
        // 选择机构
        selectMechanism(row){
            // if(this.isQuickEnteringDialog){
            //     this.quickEnteringMechanism.push({
            //         operatorMechanismId:row.id,
            //         operatorMechanism:row.name,
            //     })
            // }else{
            //     this.assignJobAgenciesData.operatorMechanismId = row.id;
            //     this.assignJobAgenciesData.operatorMechanism = row.name;
            // }
            if(this.isQuickEnteringDialog){
                this.dispatchDoubtTasks.operatorMechanismId = row.id;
                this.dispatchDoubtTasks.operatorMechanism = row.name;
                this.dispatchDoubtTasks.dcOperator = null;
                this.dispatchDoubtTasks.dcOperatorId = null;
            }else if(this.isEditAssignJobAgencies){
                this.editAssignJobAgenciesData.operatorMechanismId = row.id;
                this.editAssignJobAgenciesData.operatorMechanism = row.name;
                this.editAssignJobAgenciesData.dcOperator = null;
                this.editAssignJobAgenciesData.dcOperatorId = null;
            }else{
                this.assignJobAgenciesData.operatorMechanismId = row.id;
                this.assignJobAgenciesData.operatorMechanism = row.name;
                this.assignJobAgenciesData.dcOperator = null;
                this.assignJobAgenciesData.dcOperatorId = null;
            }
            this.isMechanismDialog = false;
            this.resetMechanism();
        },
        async productDetail(row){
            let res  = await api.queryCompanyProduct(row.id);
            this.productList = res.data.data;

            this.$forceUpdate();
        },
        async getCompanyList() {
            let res  = await api.queryCompany(this.conditionData);
            console.log(res);
            this.companyList = res.data.data;
        },
        // 机构列表
        selectDataMechanism(){
            this.conditionDataMechanism.page = 1;
            this.queryMechanism();
        },
        resetMechanism(){
            this.conditionDataMechanism = {
                Name:'',
                page:1,
                pageSize:10,
            },
            this.queryMechanism();
        },
        async queryMechanism(){
            let res = await api.QueryMechanism(this.conditionDataMechanism);
            this.mechanismList = res.data.data.data;
            this.totalCountMechanism = res.data.data.totalCount;
        },
        // 机构分页
        handleCurrentChangeMechanism(page){
            this.conditionDataMechanism.page = page;
            this.queryMechanism();
        },
        // 选择省市区
        handleRegionChange(){
            let e = this.selectedOptions;
            if(e[2]){
                this.caseData.cAccdntPlace = CodeToText[e[0]]+'-'+CodeToText[e[0],e[1]]+'-'+CodeToText[e[0],e[1],e[2]]
            }else if(e[1]){
                this.caseData.cAccdntPlace = CodeToText[e[0]]+'-'+CodeToText[e[0],e[1]]
            }
            // this.caseData.cCourAll=this.selectedOptions;
            // for(let index in this.caseData.cCourAll){
            //     this.caseData.cCourAll[index] = parseInt(this.caseData.cCourAll[index]);
            // }
        },
        
        // 图片查看
        closeViewer(){
            this.showBigImg = false;
        },
        showImg(img,list){
            let imglist = [];
            for(let i in list){
                if(list[i].fileType=='jpg'||list[i].fileType=='png'||list[i].fileType=='gif'||list[i].fileType=='jpeg'||list[i].fileType=='JPG'||list[i].fileType=='PNG'||list[i].fileType=='GIF'||list[i].fileType=='JPEG'){
                    imglist.push(list[i].path);
                    if(img==list[i].path){
                        this.imgIndex = imglist.length-1
                    }
                }
            }
            this.showBigImgList = imglist;
            this.showBigImg = true;
        },
        showImgM(img,list){
            let imglist = [];
            for(let i in list){
                if(list[i].materialType=='jpg'||list[i].materialType=='png'||list[i].materialType=='gif'||list[i].materialType=='jpeg'||list[i].materialType=='JPG'||list[i].materialType=='PNG'||list[i].materialType=='GIF'||list[i].materialType=='JPEG'){
                    imglist.push(list[i].path);
                    if(img==list[i].path){
                        this.imgIndex = imglist.length-1
                    }
                }
            }
            this.showBigImgList = imglist;
            this.showBigImg = true;
        },
        
        tableHeaderColor ({ row, column, rowIndex, columnIndex }) {
            if (rowIndex === 0) {
                return 'background-color: #F2F2F2;color: #000;'
            }
        },
        // 调查过程
        doubtCourseAddTip(){
            this.isAddDoubtCourse = true;
        },
        // 选择公司
        changeCompany(e){
            for(let index in this.companyList){
                if(this.companyList[index].id==e){
                    this.caseData.companyName = this.companyList[index].name;
                    this.caseData.cProdName = '';
                    this.productDetail({id:e});

                    this.isFinalCase = this.companyList[index].isCaseTaskComplete;
                }
            }
        },
       
        
        
        
        
        
       

        
        
        
        
        // 上传
        async uploadCPath(file){
            let name = file.file.name;
            let fileTypeList = name.split('.');
            let fileType = fileTypeList[fileTypeList.length-1];
            this.addCaseMaterial.fileType = fileType;
            let res = await api.uploadOther(file.file);
            this.addCaseMaterial.path = res;
            this.$forceUpdate();
            console.log(res);

        },
        
        // 下载资料
        download(path,name){
            this.$message({
                type: 'success',
                message: '下载成功,请稍等!'
            });
            const elt = document.createElement('a');
            elt.setAttribute('target', '_blank');
            elt.setAttribute('href', path);
            elt.setAttribute('download', name);
            elt.style.display = 'none';
            document.body.appendChild(elt);
            elt.click();
        },
       


        
        

       



        

        addSurveyDataFun(){
            if(!this.addSurveyData.cSvyNeed){
                this.$message({
                    type: 'error',
                    message: '请填写调查需求!'
                });
                return;
            }
            if(!this.addSurveyData.cSvyTypeCode){
                this.$message({
                    type: 'error',
                    message: '请填写疑案类型!'
                });
                return;
            }
            if(!this.addSurveyData.cSvyModeCode){
                this.$message({
                    type: 'error',
                    message: '请填写案件类型!'
                });
                return;
            }

            this.addSurveyDataDialog = false;
            this.surveyData.push({
                cSvyNeed:this.addSurveyData.cSvyNeed,
                cSvyNeedCode:this.addSurveyData.cSvyNeed,
                tHopeEndTm:this.addSurveyData.tHopeEndTm,
                cSvyType:this.addSurveyData.cSvyType,
                cSvyTypeCode:this.addSurveyData.cSvyTypeCode,
                cSvyMode:this.addSurveyData.cSvyMode,
                cSvyModeCode:this.addSurveyData.cSvyModeCode,
                cSvyPlace:this.addSurveyData.cSvyPlace,
                cSvyPlaceCode:this.addSurveyData.cSvyPlaceCode,
                cSvyAddr:this.addSurveyData.cSvyAddr,
            });
            this.addSurveyData = {};
            this.$forceUpdate();
        },
        // 新增资料
        async addSurveyInfo(file){
            let material = {
                // anXinDcTaskId:this.detailData.id,
                materialType:'',
                name:'',
                path:'',
            };
            material.name = file.file.name;
            let fileTypeList = material.name.split('.');
            let fileType = fileTypeList[fileTypeList.length-1];
            material.materialType = fileType;
            let res = await api.uploadOther(file.file);
            console.log(res);
            material.path = res;
            if(this.surveyInfo){
                this.surveyInfo.push(material);
            }else{
                this.surveyInfo=[material];
            }
        },
        
        // 删除资料
        clearSurveyInfoMaterial(index){
            this.surveyInfo.splice(index,1);
        },
        // 新增案件
        submitForm(formName) {
            if(this.caseData.cConclusion){
                this.researchConclusions.cConclusion = this.caseData.cConclusion;
            }
            if(this.caseData.cConcRst){
                this.researchConclusions.cConcRst = this.caseData.cConcRst;
            }
            
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.addAnXinDcTaskTip();
                } else {
                    console.log('error submit!!');
                    this.addAnXinDcTaskTip();
                }
            });

        },
        async addAnXinDcTaskTip(){
            this.caseData.isTranstion = false;
            this.addAnXinDcTask();
        },
        async addAnXinDcTask(type){
            if(!this.caseData.cClmNo){
                this.$message({
                    type: 'warning',
                    message: '请填写赔案号!'
                });
                return;
            }
            if(!this.caseData.companyId){
                this.$message({
                    type: 'warning',
                    message: '请填写保险公司!'
                });
                return;
            }
            if(!this.caseData.cProdType){
                this.$message({
                    type: 'warning',
                    message: '请填写险种类型!'
                });
                return;
            }
            if(!this.caseData.cProdName){
                this.$message({
                    type: 'warning',
                    message: '请填写保障产品!'
                });
                return;
            }
          
            if(!this.caseData.cInsuredNme){
                this.$message({
                    type: 'warning',
                    message: '请填写被保人!'
                });
                return;
            }
            if(!this.caseData.cCertType){
                this.$message({
                    type: 'warning',
                    message: '请填写被保人证件类型!'
                });
                return;
            }
            if(!this.caseData.cCertNo){
                this.$message({
                    type: 'warning',
                    message: '请填写被保人证件号!'
                });
                return;
            }
            if(!this.caseData.personDanger){
                this.$message({
                    type: 'warning',
                    message: '请填写出险人!'
                });
                return;
            }
            
            if(!this.caseData.DcTaskPgTime){
                this.$message({
                    type: 'warning',
                    message: '请填写派工时间!'
                });
                return;
            }
           
            if(this.surveyData.length==0){
                this.$message({
                    type: 'warning',
                    message: '请填写派工信息!'
                });
                return;
            }


            if(this.isFinanceDcTaskAction){
                if(!this.researchConclusions.cConclusion){
                    this.$message({
                        message: '调查结论未填！',
                        type: 'error'
                    });
                    return;
                }
                if(!this.researchConclusions.cConcRst){
                    this.$message({
                        message: '调查意见未填！',
                        type: 'error'
                    });
                    return;
                }
            }
           
                
                
            for(let i in this.caseData.dispatchDoubtTasks){
                if(!this.caseData.dispatchDoubtTasks[i].taskFee&&this.caseData.dispatchDoubtTasks[i].taskFee!=0){
                    this.$message({
                        type: 'warning',
                        message: '作业机构的公估费用未填!'
                    });
                    return;
                }else{
                    this.caseData.dispatchDoubtTasks[i].taskFee = parseFloat(this.caseData.dispatchDoubtTasks[i].taskFee);
                    this.caseData.dispatchDoubtTasks[i].rewardFee = parseFloat(this.caseData.dispatchDoubtTasks[i].rewardFee?this.caseData.dispatchDoubtTasks[i].rewardFee:0);
                    this.caseData.dispatchDoubtTasks[i].ydPrice = parseFloat(this.caseData.dispatchDoubtTasks[i].ydPrice?this.caseData.dispatchDoubtTasks[i].ydPrice:0);
                }
                
            }

            if(this.isFinanceDcTaskAction){
                this.caseData.dcTaskAction = 40;
            }
            this.caseData.materialItems = this.surveyInfo;
            this.caseData.anXinDoubtDetails = this.surveyData;
            this.caseData.appraisalFee = parseFloat(this.caseData.appraisalFee?this.caseData.appraisalFee:0);
            

            //console.log(this.caseData);
            //return false;

            let res;
            if(type==2){
                res = await api.addXHBDcTask(this.caseData);
                if(type==2&&this.isFinanceDcTaskAction){
                    this.updateCccnn(res.data.data[0].anXinDcTaskId);
                }
            }else{
                res = await api.addAnXinDcTask(this.caseData);
                if(this.isFinalCase&&this.isFinanceDcTaskAction){
                    this.updateCccnn(res.data.data[0].anXinDcTaskId);
                }
            }
            if(res.data.code == '200'){
                this.addData.DcTaskPgTime = null;
                this.addData.cSvyModeCode = null;
                this.isQuickEnteringDialog = false;
                this.caseData = {
                    cClmNo:'',
                    cProdName:'',
                    dispatchDoubtTasks:[],
                    materialItems:[],
                }
                this.surveyInfo=[];
                this.surveyData=[];
                this.selectedOptions = [];
                this.dataStr = "";
                this.dispatchDoubtTasks={
                    operatorMechanism:localStorage.getItem('mechanism'),
                    operatorMechanismId:localStorage.getItem('mechanismid'),
                    dcOperator:'',
                    dcOperatorId:null,
                    dcyq:'',
                    isZhuPaiJiGou:false,
                    taskFee:null,
                    taskFeeReason:null,
                    rewardFee:null,
                    isPush: false,
                    ydPrice: null
                }
                this.isFinanceDcTaskAction = false;
                if(res.data.data.length>0){
                    this.pushAnXinDcTaskFinance(res.data.data);
                    
                }else{
                    this.$message({
                        type: 'success',
                        message: '新增成功'
                    }); 
                }
            }
        },
        async pushAnXinDcTaskFinance(data){
            let res = await api.pushAnXinDcTaskFinance(data);
            if(res.data.code == '200'){
                this.$message({
                    type: 'success',
                    message: '新增成功'
                });  
            }
        },
        // // 设置公估费
        // async setDcTaskAppraisal(){
        //     let res = await api.setDcTaskAppraisal();
        // },
        // 调查信息查询
        surveyDataItemDialogOpen(detail,index){
            console.log(index);
            this.surveyDataIndex = index;
            this.surveyDataItemDialog = true;
            this.surveyDataItem = detail;
        },
        changeCSvyPlace(e){
            for(let index in this.cSvyPlaceList){
                if(this.cSvyPlaceList[index].value==e){
                    if(this.surveyDataItemDialog){
                        this.surveyDataItem.cSvyPlace = this.cSvyPlaceList[index].label
                    }else if (this.addSurveyDataDialog) {
                        this.addSurveyData.cSvyPlace = this.cSvyPlaceList[index].label
                    }else if (this.isQuickEnteringDialog) {
                        this.addData.cSvyPlace = this.cSvyPlaceList[index].label
                    }
                    return;
                }
            }
        },
        changeCSvyNeed(e){
            for(let index in this.cSvyNeedList){
                if(this.cSvyNeedList[index].value==e){
                    if(this.surveyDataItemDialog){
                        this.surveyDataItem.cSvyNeed = this.cSvyNeedList[index].label
                    }else if (this.addSurveyDataDialog) {
                        this.addSurveyData.cSvyNeed = this.cSvyNeedList[index].label
                    }else if (this.isQuickEnteringDialog) {
                        this.addData.cSvyNeed = this.cSvyNeedList[index].label
                    }
                    return;

                }
            }
        },
        changeCSvyType(e){
            for(let index in this.cSvyTypeList){
                if(this.cSvyTypeList[index].value==e){
                    if(this.surveyDataItemDialog){
                        this.surveyDataItem.cSvyType = this.cSvyTypeList[index].label
                    }else if (this.addSurveyDataDialog) {
                        this.addSurveyData.cSvyType = this.cSvyTypeList[index].label
                    }else if (this.isQuickEnteringDialog) {
                        this.addData.cSvyType = this.cSvyTypeList[index].label
                    }
                    return;

                }
            }
        },
        changeCSvyMode(e){
            for(let index in this.cSvyModeList){
                if(this.cSvyModeList[index].value==e){
                    if(this.surveyDataItemDialog){
                        this.surveyDataItem.cSvyMode = this.cSvyModeList[index].label
                    }else if (this.addSurveyDataDialog) {
                        this.addSurveyData.cSvyMode = this.cSvyModeList[index].label
                    }else if (this.isQuickEnteringDialog) {
                        this.addData.cSvyMode = this.cSvyModeList[index].label
                    }
                    return;

                }
            }
        },

        // 查询
        async querySearch(queryString, cb){
            let list = this.cSvyNeedList;
            console.log(queryString);
            let results = queryString ? list.filter(this.createFilter(queryString)) : list;
            console.log(results);
            cb(results);
        },
        handleSelect(e){
            console.log(e);
            if(this.surveyDataItemDialog){
                this.surveyDataItem.cSvyNeed = e.label;
                this.surveyDataItem.cSvyNeedCode = e.label;
            }else if (this.addSurveyDataDialog) {
                this.addSurveyData.cSvyNeed = e.label;
                this.addSurveyData.cSvyNeedCode = e.label;
            }
        },
        createFilter(queryString) {
            return (list) => {
                return (list.label.toLowerCase().indexOf(queryString.toLowerCase()) != -1);
            };
        },


        async dataSubmit(formName){
            

            if(this.dispatchDoubtTasks.DcTaskPgTime){
                this.addData.DcTaskPgTime = this.dispatchDoubtTasks.DcTaskPgTime
            }
            if(this.dispatchDoubtTasks.cSvyModeCode){
                this.addData.cSvyModeCode = this.dispatchDoubtTasks.cSvyModeCode
            }
            if(this.dispatchDoubtTasks.cConclusion){
                this.researchConclusions.cConclusion = this.dispatchDoubtTasks.cConclusion;
            }
            if(this.dispatchDoubtTasks.cConcRst){
                this.researchConclusions.cConcRst = this.dispatchDoubtTasks.cConcRst;
            }
            
            this.$refs[formName].validate((valid) => {
                if (valid) {
                } else {
                }
            });


            if(!this.dispatchDoubtTasks.dcOperator){
                this.$message({
                    message: '调查员未填！',
                    type: 'error'
                });
                return;
            }
            if(!this.addData.DcTaskPgTime){
                this.$message({
                    message: '派工时间未填！',
                    type: 'error'
                });
                return;
            }
            if(!this.addData.cSvyModeCode){
                this.$message({
                    message: '案件类型未填！',
                    type: 'error'
                });
                return;
            }
            if(!this.dispatchDoubtTasks.taskFee&&this.dispatchDoubtTasks.taskFee!=0){
                this.$message({
                    message: '公估费用未填！',
                    type: 'error'
                });
                return;
            }
            else if(this.dispatchDoubtTasks.taskFee==0){
                if(this.dispatchDoubtTasks.taskFeeReason==''){
                    this.$message({
                        message: '公估费用为0原因未填！',
                        type: 'error'
                    });
                    return;
                }
            }
            if(this.isFinanceDcTaskAction){
                if(!this.researchConclusions.cConclusion){
                    this.$message({
                        message: '调查结论未填！',
                        type: 'error'
                    });
                    return;
                }
                if(!this.researchConclusions.cConcRst){
                    this.$message({
                        message: '调查意见未填！',
                        type: 'error'
                    });
                    return;
                }
            }
            
            
            
            
            this.dispatchDoubtTasks.taskFee = parseFloat(this.dispatchDoubtTasks.taskFee);
            this.dispatchDoubtTasks.ydPrice = parseFloat(this.dispatchDoubtTasks.ydPrice);

            if(this.dispatchDoubtTasks.taskFee > 0){
                this.dispatchDoubtTasks.taskFeeReason = '';
            }

            this.dispatchDoubtTasks.rewardFee = parseFloat(this.dispatchDoubtTasks.rewardFee?this.dispatchDoubtTasks.rewardFee:0);
            
            this.caseData.dispatchDoubtTasks = [];
            this.surveyData=[];
            let res = await api.addQuickAsync({
                data:this.dataStr
            });
            if(res.data.code == '200'){
                let resData = res.data.data;
                for(let key in resData){
                    if(resData[key]!=null&&resData[key].length>0){
                        this.caseData[key] = resData[key]
                    }
                }
                if(resData['materialItems']){
                    this.surveyInfo = this.surveyInfo.concat(resData['materialItems']);
                }
                if(resData['anXinDoubtDetails']){
                    this.surveyData = this.surveyData.concat(resData['anXinDoubtDetails']);
                }
                
                if(this.addData.DcTaskPgTime){
                    this.caseData.DcTaskPgTime = this.addData.DcTaskPgTime;
                }

                let addSurveyData = {};
                if(this.addData.cSvyModeCode){
                    addSurveyData.cSvyModeCode = this.addData.cSvyModeCode;
                }
                if(this.addData.cSvyMode){
                    addSurveyData.cSvyMode = this.addData.cSvyMode;
                }
                if(this.addData.cSvyTypeCode){
                    addSurveyData.cSvyTypeCode = this.addData.cSvyTypeCode;
                }
                if(this.addData.cSvyTypeCode=='7'){
                    addSurveyData.cSvyType = '其他';
                }
                if(this.addData.cSvyType){
                    addSurveyData.cSvyType = this.addData.cSvyType;
                }
                if(this.isFinanceDcTaskAction){
                    this.caseData.dcTaskAction = 40;
                }

                this.caseData.dispatchDoubtTasks.push(this.dispatchDoubtTasks)
                this.caseData.cProdName = '健康险';
                this.surveyData.push(addSurveyData);
                this.caseData.isTranstion = true;

                
                this.addAnXinDcTask(2);
                this.$forceUpdate();
            }
        },

        async affirmMechanism(){
            
            if(!this.assignJobAgenciesData.taskFee&&this.assignJobAgenciesData.taskFee!='0'){
                this.$message({
                    message: '公估费用未填！',
                    type: 'error'
                });
                return;
            }
            if(this.assignJobAgenciesData.taskFee == '0'){
                if(!this.assignJobAgenciesData.taskFeeReason){
                    this.$message({
                        message: '公估费用为0原因未填！',
                        type: 'error'
                    });
                    return;
                }
            }

            if(this.assignJobAgenciesData.taskFee > 0){
                this.assignJobAgenciesData.taskFeeReason = '';
                
            }
            
            this.isAssignJobAgencies = false;
            // if(this.isQuickEnteringDialog){
            //     this.dispatchDoubtTasks.push({
            //         operatorMechanism:this.assignJobAgenciesData.operatorMechanism,
            //         operatorMechanismId:this.assignJobAgenciesData.operatorMechanismId,
            //         dcOperator:this.assignJobAgenciesData.dcOperator,
            //         dcOperatorId:this.assignJobAgenciesData.dcOperatorId,
            //         dcyq:this.assignJobAgenciesData.dcyq,
            //         isZhuPaiJiGou:this.assignJobAgenciesData.isZhuPaiJiGou,
            //         taskFee:parseFloat(this.assignJobAgenciesData.taskFee),
            //         taskFeeReason:this.assignJobAgenciesData.taskFeeReason,
            //     })
            // }else{
                if(this.assignJobAgenciesData.isZhuPaiJiGou){
                    for(let i in this.caseData.dispatchDoubtTasks){
                        this.caseData.dispatchDoubtTasks[i].isZhuPaiJiGou = false;
                    }
                }
                if(this.assignJobAgenciesData.isPush){
                    for(let i in this.caseData.dispatchDoubtTasks){
                        this.caseData.dispatchDoubtTasks[i].isPush = false;
                    }
                }
                this.caseData.dispatchDoubtTasks.push({
                    operatorMechanism:this.assignJobAgenciesData.operatorMechanism,
                    operatorMechanismId:this.assignJobAgenciesData.operatorMechanismId,
                    dcOperator:this.assignJobAgenciesData.dcOperator,
                    dcOperatorId:this.assignJobAgenciesData.dcOperatorId,
                    dcyq:this.assignJobAgenciesData.dcyq,
                    isZhuPaiJiGou:this.assignJobAgenciesData.isZhuPaiJiGou,
                    taskFee:parseFloat(this.assignJobAgenciesData.taskFee),
                    taskFeeReason:this.assignJobAgenciesData.taskFeeReason,
                    isPush: this.assignJobAgenciesData.isPush,
                    rewardFee:parseFloat(this.assignJobAgenciesData.rewardFee?this.assignJobAgenciesData.rewardFee:0),
                    ydPrice:parseFloat(this.assignJobAgenciesData.ydPrice?this.assignJobAgenciesData.ydPrice:0)
                })
            // }
            
            this.assignJobAgenciesData = {
                isZhuPaiJiGou:false,
                isPush: false
            };
            this.$forceUpdate();
        },
        handleCurrentChangeUser(page){
            this.userConditionData.page = page;
            this.queryUserByMechanismId();
        },
        selectUserData(){
            this.userConditionData.page = 1;
            this.queryUserByMechanismId();
        },
        resetUser(){
            this.userConditionData.name = "";
            this.userConditionData.page = 1;
            this.queryUserByMechanismId();
        },
        // 选择人员
        async selectOperator(){
            this.queryUserByMechanismId();
        },
        // 人员列表
        async queryUserByMechanismId(){
                let operatorMechanismId = null;
                
                if(this.assignJobAgenciesData.operatorMechanismId){
                    operatorMechanismId = this.assignJobAgenciesData.operatorMechanismId;
                }else if(this.isEditAssignJobAgencies&&this.editAssignJobAgenciesData.operatorMechanismId){
                    operatorMechanismId = this.editAssignJobAgenciesData.operatorMechanismId;
                }else if(this.dispatchDoubtTasks.operatorMechanismId&&this.isQuickEnteringDialog){
                    operatorMechanismId = this.dispatchDoubtTasks.operatorMechanismId;
                }else{
                    this.$message({
                        type: 'error',
                        message: '未选择机构!'
                    });  
                    return
                }
                this.userConditionData.MechanismIds = [operatorMechanismId]
                let res = await api.QueryUsers(this.userConditionData);
                if(res.data.data){
                    this.userDialog = true;
                    this.userList = res.data.data.data;
                    this.userTotalCount = res.data.data.totalCount;
                }
        },
        selectPerson(row){
            
            if(this.isQuickEnteringDialog){
                this.dispatchDoubtTasks.dcOperator = row.name;
                this.dispatchDoubtTasks.dcOperatorId = row.id;
            }else if(this.isEditAssignJobAgencies){
                this.editAssignJobAgenciesData.dcOperator = row.name;
                this.editAssignJobAgenciesData.dcOperatorId = row.id;
            }else{
                this.assignJobAgenciesData.dcOperator = row.name;
                this.assignJobAgenciesData.dcOperatorId = row.id;
            }
            
            this.userDialog = false;
        },

        deleteSurveyDataItem(index){
            this.surveyData.splice(index,1);
        },
        cancelAssign(index){
            this.caseData.dispatchDoubtTasks.splice(index,1);
        },
        editAssignTip(index){
            this.editAssignJobAgenciesData = this.caseData.dispatchDoubtTasks[index];
            this.isEditAssignJobAgencies = true;
            this.assignJobAgenciesDataIndex = index
            console.log(this.editAssignJobAgenciesData);
        },
        editAffirmMechanism(){
            if(!this.editAssignJobAgenciesData.taskFee&&this.editAssignJobAgenciesData.taskFee!='0'){
                this.$message({
                    message: '公估费用未填！',
                    type: 'error'
                });
                return;
            }
            if(this.editAssignJobAgenciesData.taskFee == '0'){
                if(!this.editAssignJobAgenciesData.taskFeeReason){
                    this.$message({
                        message: '公估费用为0原因未填！',
                        type: 'error'
                    });
                    return;
                }
            }
            // console.log(this.editAssignJobAgenciesData.isPush);
            // console.log(this.editAssignJobAgenciesData);
            // return false;
            this.caseData.dispatchDoubtTasks[this.assignJobAgenciesDataIndex] = this.editAssignJobAgenciesData;
            this.isEditAssignJobAgencies = false;
            this.editAssignJobAgenciesData={};
            return;
        },
         // 编辑调查结论
        async updateCccnn(id){
            let res = await api.UpdateCccnn({
                anXinDcTaskId:id,
                cConclusion:this.researchConclusions.cConclusion,
                cConcRst:this.researchConclusions.cConcRst,
                cRefuseRsn:this.researchConclusions.cRefuseRsn,
                nRefusePayAmt:parseFloat(this.researchConclusions.nRefusePayAmt?this.researchConclusions.nRefusePayAmt:0),
                nDeroAmt:parseFloat(this.researchConclusions.nDeroAmt?this.researchConclusions.nDeroAmt:0),
            });
            if(res.data.code == '200'){
                this.researchConclusions={
                    cConclusion:'',
                    cConcRst:'',
                    cRefuseRsn:'',
                    nRefusePayAmt:'',
                    nDeroAmt:'',
                }
            }
            
                    
        },

        downloadExcel(){
            window.location.href='https://txggpic.oss-cn-shenzhen.aliyuncs.com/20230314/%E6%A0%87%E5%87%86%E6%A1%88%E4%BB%B6%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx'
        },
        async batchImport(file){
            let res = await api.importFreeRecord(file.file,{
                Type:this.batchImportType,
            });
            if(res.data.code == 200){
                this.$message({
                    type: 'success',
                    message: '导入成功'
                });
                this.isBatchImportDialog = false;
            }
        },
    }
    
}
</script>

<style lang="scss" scoped>
    .condition{
        display: flex;
        align-items: center;
    }
    /deep/.el-select{
        width: 100%;
    }
    /deep/.el-input.is-disabled .el-input__inner{
        color:#606266;
    }
    /deep/.el-form-item__label{
        width: 140px !important;
    }
    /deep/.el-form-item__content{
        margin-left: 140px!important;
    }
    /deep/.el-date-editor.el-input, /deep/.el-input__inner{
        width:215px !important;
    }
    /deep/.el-autocomplete .el-input__inner{
        width:100% !important;
    }
    .top{
        display: flex;
        justify-content: space-between;
        padding:10px;
        background-color: #ffffff;
    }
    .handle{
        margin-bottom: 10px;
    }
    .dialog-btn{
        width: 100%;
        display: flex;
        justify-content: center;
    }
    .section{
        height: 100%;
        display: flex;
        flex-wrap: wrap;
        border: 1px solid #DEDEDE;
        margin-bottom: 15px;
        padding-bottom: 10px;
        .title{
            width: 100%;
            font-weight: bold;
            font-size: 16px;
            margin-bottom: 12px;
            background-color: #DEDEDE;
            padding:8px 15px;
            display: flex;
            align-items: center;
            .dot{
                color: red;
                font-size: 20px;
            }
        }
        .item{
            font-size: 14px;
            padding:10px 15px;
            display: flex;
            align-items: center;
            .label{
                margin-bottom: 5px;
                width: 120px;
                display: flex;
                align-items: center;
                .dot{
                    color: red;
                    font-size: 20px;
                }
            }
            
            .value{
                width: 220px;
                display: flex;
            }
            .piclist{
                width: 100%;
                display: flex;
                align-items: center;
                flex-wrap: wrap;
                padding:10px 15px;
                .label{
                    width: 230px;
                    font-size: 14px;
                }
                .pics{
                    display: flex;
                    flex-wrap: wrap;
                    .pics-item{
                        width: 100px;
                        height: 100px;
                        position: relative;
                        margin: 15px;
                        .img{
                            width: 100px;
                            height: 100px;
                        }
                        .close{
                            position: absolute;
                            top: -12px;
                            right: -12px;
                            width: 24px;
                            height: 24px;
                        }
                    }
                }
                .uploadbtn{
                    border: 1px solid #dcdcdc;
                    width: 106px;
                    height: 106px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin: 15px;
                    img{
                        width: 106px;
                        height: 106px;
                    }
                }
                
            }
        }

    }
    .item{
        font-size: 14px;
        padding:10px 15px;
        display: flex;
        align-items: center;
        .label{
            margin-bottom: 5px;
            width: 120px;
            display: flex;
            align-items: center;
            .dot{
                color: red;
                font-size: 20px;
            }
        }
        .inline-input{
            width: 100%;
        }
        .value{
            min-width: 220px;
            display: flex;
        }
        .piclist{
            width: 100%;
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            padding:10px 15px;
            .label{
                width: 230px;
                font-size: 14px;
            }
            .pics{
                display: flex;
                flex-wrap: wrap;
                .pics-item{
                    width: 100px;
                    height: 100px;
                    position: relative;
                    margin: 15px;
                    .img{
                        width: 100px;
                        height: 100px;
                    }
                    .close{
                        position: absolute;
                        top: -12px;
                        right: -12px;
                        width: 24px;
                        height: 24px;
                    }
                }
            }
            .uploadbtn{
                border: 1px solid #dcdcdc;
                width: 106px;
                height: 106px;
                display: flex;
                align-items: center;
                justify-content: center;
                margin: 15px;
                img{
                    width: 106px;
                    height: 106px;
                }
            }
            
        }
    }
    .btns{
        width: 100%;
        display: flex;
        justify-content: center;
    }
    .taskreason{
        span{
            color: red;
            font-size: 18px;
        }
        font-size: 14px;
        margin: 10px 0;
    }
    .materiallist{
        display: flex;
        flex-wrap: wrap;
        margin-bottom: 15px;
        align-items: center;
        .material{
            border: 1px dashed #dcdcdc;
            width: 150px;
            height: 170px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            overflow: hidden;
            text-overflow:ellipsis;
            white-space: nowrap;
            border-radius: 4px;
            margin:10px;
            position: relative;
            img{
                width: 120px;
            }
            .close{
                width: 25px;
                height: 25px;
                position: absolute;
                right: 3px;
                top: 3px;
            }
            .filename{
                width: 130px;
                font-size: 12px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                text-align: center;
                margin-top: 2px;
            }
        }
    }
    .section-item{
        display: flex;
        flex-wrap: wrap;
        border: 1px solid #DEDEDE;
        margin-bottom: 10px;
        .stitle{
            background-color: #f1f1f1;
            width: 100%;
            font-weight: bold;
            font-size: 16px;
            margin-bottom: 12px;
            border-bottom:1px solid #DEDEDE;
            padding:8px 15px;
        }
        
    }
    .inputs{
        display: flex;
        flex-wrap: wrap;
        margin-top: 10px;
        .value{
            display: flex;
        }
    }
    /deep/.el-step.is-simple .el-step__title{
        font-size: 14px;
    } 
    /deep/.el-steps--simple{
        padding:  0px;
        background-color: #ffffff;
    }
    /deep/.el-steps{
        width: 1000px;
    }
    /deep/.el-step.is-simple .el-step__arrow::after, /deep/.el-step.is-simple .el-step__arrow::before{
        height: 9px !important;
    }
    
    /deep/.el-step.is-simple .el-step__arrow::after{
        transform: rotate(45deg) translateY(3px);
    }
    /deep/.el-step.is-simple .el-step__arrow::before{
        transform: rotate(-45deg) translateY(-3px);
    }
    .btn-bottom{
        display: flex;
        justify-content: center;
        margin-top: 50px;
    }
    // .mechanismlist{
    //     border:1px solid #DCDFE6;
    //     width: 567px;
    //     border-radius: 4px;
    //     padding: 5px 14px;
    //     font-size: 13px;
    //     line-height: 24px;
    //     /deep/.el-tag{
    //         margin: 5px 0;

    //         margin-right: 10px;
    //     }
    // }
    
    .product-report-btn{
        display: flex;
        justify-content: center;
    }
    .product-report-radio{
        display: flex;
        justify-content: space-between;
        margin-top: 20px;
        margin-bottom: 20px;
        align-items: center;
    }
</style>
